export default __webpack_public_path__ + "static/media/12.1960aa52.png";